import { createFileRoute } from "@tanstack/react-router";
import { ExperimentPage } from "@/features/experiments/experiment-page";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/experiments/$id")({
  validateSearch: uploadSearch,
  component: Page,
});
function Page() {
  const { id } = Route.useParams();
  return <ExperimentPage id={id} />;
}
